import React from 'react'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import classNames from 'classnames'
import type { TLandingCardWithIconProps } from './types'
import './styles.scss'

export const LandingCardWithIcon: React.FC<TLandingCardWithIconProps> = ({ iconName, iconSize, children, className }) => {
  return (
    <div className={classNames(className, 'landingCardWithIcon')}>
      <div className="landingCardWithIcon__iconWrapper">
        <Icon name={iconName} size={iconSize} />
      </div>
      {children}
    </div>
  )
}
